'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductCardContainer = exports.mapStateToProps = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _universalLogger = require('universal-logger');

var logger = _interopRequireWildcard(_universalLogger);

var _deep = require('helpers/deep');

var _verify = require('helpers/verify');

var _decorator = require('helpers/decorator');

var _Base = require('derivers/Base64');

var _Base2 = _interopRequireDefault(_Base);

var _TrackDwell = require('decorators/TrackDwell/TrackDwell');

var _TrackDwell2 = _interopRequireDefault(_TrackDwell);

var _Sagas = require('decorators/Sagas');

var _homepage = require('redux/modules/features/homepage');

var _bound = require('redux/saga/entities/bound');

var _msas = require('redux/saga/selectors/msas');

var _ProductCard = require('./ProductCard');

var _ProductCard2 = require('./ProductCard.saga');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messages = (0, _reactIntl.defineMessages)({
  ctaSelect: {
    id: 'product-card.card.cta.select',
    defaultMessage: 'Select'
  },
  disclaimerAutoRenewal: {
    id: 'product-card.disclaimer.autoRenewal',
    defaultMessage: 'After your free trial, you’ll auto-enroll in our {price}/month plan. Change or cancel any time during your trial to not be charged.'
  },
  firstMonthOfferNote: {
    id: 'product-card.card.first-month-offer-note',
    defaultMessage: '~~{originalPrice}~~ first month'
  },
  planDetails: {
    id: 'product-card.card.plan-details',
    defaultMessage: 'Includes __{creditsPerCycle, number}&nbsp;credits__ to book __{minClassEstimate, number}&nbsp;-&nbsp;{maxClassEstimate, number}&nbsp;classes__'
  }
});

function formatPrice(intl, msa, price, withFractionDigits) {
  return intl.formatNumber(Math.max(0, price), (0, _extends3.default)({
    style: 'currency',
    currency: msa.currency_code
  }, !withFractionDigits && {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  }));
}

function formatPlanDetails(intl, plan) {
  var creditsPerCycle = plan.credits_per_cycle,
      maxClassEstimate = plan.max_class_estimate,
      minClassEstimate = plan.min_class_estimate;


  if ([creditsPerCycle, maxClassEstimate, minClassEstimate].some(_verify.isAbsent)) {
    logger.warn('Incomplete plan data for plan [' + plan.id + ']');
    return '';
  }

  // NOTE: non-breaking elements to ensure proper formatting
  return intl.formatMessage(messages.planDetails, {
    creditsPerCycle: creditsPerCycle,
    minClassEstimate: minClassEstimate,
    maxClassEstimate: maxClassEstimate
  });
}

var mapCustomCard = function mapCustomCard() {
  return {
    // do nothing since the component will just use all the props
    // from the module to populate the UI
  };
};

var mapPromoCard = function mapPromoCard(state, props) {
  var callout = props.callout,
      calloutNote = props.calloutNote,
      cmsModuleId = props.cmsModuleId,
      ctaCopy = props.ctaCopy,
      details = props.details,
      disclaimer = props.disclaimer,
      disclaimerType = props.disclaimerType,
      intl = props.intl,
      productCode = props.productCode,
      tag = props.tag,
      url = props.url;

  var msa = (0, _msas.msaByIdentifier)(_bound.msas.data(state), (0, _homepage.selectMsaId)(state)) || {};
  if ((0, _verify.isEmpty)(msa)) {
    return {};
  }

  var key = _bound.promotionByAlias.defaultKey(null, productCode, msa.id);
  var promotion = _bound.promotionByAlias.data(state, key) || {};
  var offers = promotion.offers || [];
  var cards = offers.map(function (offer) {
    var originalPrice = formatPrice(intl, msa, offer.recurring_plan.price);
    var isSingleMonth = offer.initial_duration_formatted === '1 month';
    // Note: backwards compatabile for non-required price terms
    var note = (0, _deep.deepExtract)('content.card.price_terms', offer) || isSingleMonth && intl.formatMessage(messages.firstMonthOfferNote, { originalPrice: originalPrice }) || '';

    var disclaimerNote = disclaimerType === _ProductCard2.PRODUCT_CARD_DISCLAIMER_TYPES.autoRenewal ? intl.formatMessage(messages.disclaimerAutoRenewal, {
      price: formatPrice(intl, msa, offer.recurring_plan.price, true)
    }) : '';

    return {
      callout: formatPrice(intl, msa, offer.price),
      calloutNote: note,
      cta: (0, _deep.deepExtract)('content.card.cta_copy', offer) || intl.formatMessage(messages.ctaSelect),
      details: formatPlanDetails(intl, offer.initial_plan),
      disclaimer: disclaimerNote,
      tag: (0, _deep.deepExtract)('content.card.tag', offer, ''),
      url: '/signup/offer/' + _Base2.default.encode(offer.id)
    };
  });
  var card = (0, _verify.isEmpty)(cards) ? {} : cards[0];
  return {
    cmsModuleId: cmsModuleId,
    callout: callout || card.callout,
    calloutNote: calloutNote || card.calloutNote,
    ctaCopy: ctaCopy || card.cta,
    details: details || card.details,
    disclaimer: disclaimer || card.disclaimer,
    tag: tag || card.tag,
    url: url || card.url
  };
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, props) {
  var cardData = void 0;
  var productType = props.productType;

  switch (productType) {
    case _ProductCard2.PRODUCT_CARD_TYPES.promotion:
      cardData = mapPromoCard(state, props);
      break;

    case _ProductCard2.PRODUCT_CARD_TYPES.custom:
    default:
      // do nothing since the component will just use all the props
      // from the module to populate the UI
      cardData = mapCustomCard(state, props);
  }

  return (0, _extends3.default)({}, cardData);
};

var ProductCardContainer = exports.ProductCardContainer = (0, _decorator.decorateWith)(_TrackDwell2.default, (0, _Sagas.withSagas)({ load: _ProductCard2.loadSaga }), (0, _reactRedux.connect)(mapStateToProps, null), _reactIntl.injectIntl)(_ProductCard.ProductCard);

ProductCardContainer.propTypes = (0, _extends3.default)({}, _ProductCard.ProductCard.propTypes, {
  intl: _reactIntl.intlShape.isRequired,
  disclaimerType: _propTypes2.default.oneOf([_ProductCard2.PRODUCT_CARD_DISCLAIMER_TYPES.none, _ProductCard2.PRODUCT_CARD_DISCLAIMER_TYPES.autoRenewal]),
  productType: _propTypes2.default.oneOf([_ProductCard2.PRODUCT_CARD_TYPES.custom, _ProductCard2.PRODUCT_CARD_TYPES.promotion]),
  productCode: _propTypes2.default.string
});